import { useEffect, useState } from "react";
import api from "@/lib/api";

export function DocumentTemplateSelect({ kind, value, onChange, disabled = false, jobId, jobs = [], inherit = false }) {
  const [options, setOptions] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let current = true;
    api.get("/document-templates", {__flSkipReadCache: true}).then(({data}) => { if (current) setOptions(data); })
      .catch(() => { if (current) setError(true); });
    return () => { current = false; };
  }, []);
  const effectiveValue = inherit && value === undefined ? (jobs.find(job => job.id === jobId)?.[`${kind}_template_id`] || options?.defaults?.[kind] || "") : value;
  const items = (options?.templates || []).filter(t => t.document_type === kind && (t.active || t.id === effectiveValue));
  return <label className="block text-sm space-y-1.5">
    <span className="font-medium">{kind === "quote" ? "Quote template" : "Invoice template"}</span>
    <select aria-label={`${kind} template`} value={effectiveValue || ""} disabled={disabled || !options}
      onChange={e => onChange(e.target.value, items.find(t => t.id === e.target.value)?.config)} className="block w-full min-h-11 px-3 rounded-md border border-border bg-background text-foreground">
      <option value="">{error ? "Could not load templates" : !options ? "Loading templates…" : "Existing Fieldlink presentation"}</option>
      {effectiveValue && !items.some(t => t.id === effectiveValue) && <option value={effectiveValue}>Saved template</option>}
      {items.map(t => <option key={t.id} value={t.id} disabled={!t.active}>{t.name}{options.defaults?.[kind] === t.id ? " · Company default" : ""}{!t.active ? " (archived)" : ""}</option>)}
    </select>
  </label>;
}

export function JobDocumentTemplates({ value, onChange, isExistingJob = false }) {
  const [options, setOptions] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let current = true;
    api.get("/document-templates", {__flSkipReadCache: true}).then(({data}) => {
      if (!current) return;
      setOptions(data);
      if (!isExistingJob) {
        const fields = {};
        for (const kind of ["quote", "invoice"]) if (value[`${kind}_template_id`] === undefined) fields[`${kind}_template_id`] = data.defaults?.[kind] || null;
        if (Object.keys(fields).length) onChange(fields);
      }
    }).catch(() => { if (current) setError(true); });
    return () => { current = false; };
    // Initialise once; later selections belong to the user.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <section className="mt-5 border-t border-border pt-4 space-y-3" data-testid="job-document-templates">
    <div className="flex flex-wrap items-center justify-between gap-2"><h3 className="text-sm font-semibold">Document templates</h3>
      <button type="button" disabled={!options} className="text-sm text-[#FF5F15] disabled:opacity-50 min-h-11" onClick={() => onChange({...value, quote_template_id:options.defaults?.quote || null, invoice_template_id:options.defaults?.invoice || null})}>Use company defaults</button>
    </div>
    <div className="grid sm:grid-cols-2 gap-3">{["quote", "invoice"].map(kind => <label key={kind} className="block text-sm space-y-1.5"><span>{kind === "quote" ? "Quote template" : "Invoice template"}</span>
      <select className="block w-full min-h-11 px-3 rounded-md border border-border bg-background" disabled={!options} value={value[`${kind}_template_id`] || ""} onChange={e => onChange({...value, [`${kind}_template_id`]: e.target.value || null})}>
        <option value="">{!options ? "Loading…" : "Company default / Fieldlink presentation"}</option>
        {(options?.templates || []).filter(t => t.document_type === kind && (t.active || t.id === value[`${kind}_template_id`])).map(t => <option key={t.id} value={t.id} disabled={!t.active}>{t.name}{!t.active ? " (archived)" : ""}{options.defaults?.[kind] === t.id ? " · Company default" : ""}</option>)}
      </select>
    </label>)}</div>
    <p className="text-xs text-muted-foreground">Applies to future documents only. You can choose a different template on each draft quote or invoice.</p>
    {error && <p role="alert" className="text-sm text-red-600">Templates could not load. Company defaults will be applied when a new job is saved.</p>}
  </section>;
}
